<template>
  <div>
    <v-card-title class="align-start">
      <div>
        <p class="mb-2">
          Dashboard e Relatórios
        </p>
      </div>
    </v-card-title>
    <v-card-text>
      <v-row>
        <v-col
          cols="12"
          sm="12"
          class="d-flex flex-column mb-5"
        >
          <div class="d-flex align-center mb-5">
            <v-avatar
              class="v-avatar-light-bg primary--text"
              rounded
              size="40"
            >
              <v-icon
                size="30"
                color="primary"
              >
                {{ icons.mdiRobotOutline }}
              </v-icon>
            </v-avatar>
            <div class="ms-4 d-flex flex-column">
              <p class="text--primary mb-0 text-base">
                Nome: {{ dadosBot.nome }}
              </p>
              <span class="text--primary font-weight-semibold text-l">Árvore: {{ dadosBot.arvore }}</span>
            </div>
          </div>
        </v-col>

        <v-col
          v-if="!temDados"
          cols="12"
          sm="12"
          class="mt-10"
        >
          <div class="d-flex justify-center mt-10">
            <span class="title font-weight-semibold overflow-auto">
              Nenhum dado disponível para o período
            </span>
          </div>
        </v-col>

        <v-col
          v-else
          cols="12"
          sm="12"
        >
          <v-row class="match-height">
            <v-col
              cols="12"
              sm="4"
            >
              <v-card
                outlined
                class="fill-height"
              >
                <v-card-text>
                  <v-avatar
                    color="primary"
                    rounded
                    size="42"
                    class="mb-3"
                  >
                    <v-icon
                      size="26"
                      color="white"
                    >
                      {{ icons.mdiChatOutline }}
                    </v-icon>
                  </v-avatar>
                  <p class="text-xs text--secondary mb-1">
                    Total de acionamentos
                  </p>
                  <p class="text-2xl font-weight-semibold text--primary mb-0">
                    {{ totalAtendimentos }}
                  </p>
                </v-card-text>
              </v-card>
            </v-col>

            <v-col
              cols="12"
              sm="4"
            >
              <v-card
                outlined
                class="fill-height"
              >
                <v-card-text>
                  <v-avatar
                    color="success"
                    rounded
                    size="42"
                    class="mb-3"
                  >
                    <v-icon
                      size="26"
                      color="white"
                    >
                      {{ icons.mdiTicketConfirmationOutline }}
                    </v-icon>
                  </v-avatar>
                  <p class="text-xs text--secondary mb-1">
                    Total de tickets abertos
                  </p>
                  <p class="text-2xl font-weight-semibold text--primary mb-0">
                    {{ totalTickets }}
                  </p>
                </v-card-text>
              </v-card>
            </v-col>

            <v-col
              cols="12"
              sm="4"
            >
              <v-card
                outlined
                class="fill-height"
              >
                <v-card-text>
                  <v-avatar
                    color="warning"
                    rounded
                    size="42"
                    class="mb-3"
                  >
                    <v-icon
                      size="26"
                      color="white"
                    >
                      {{ icons.mdiTrendingUp }}
                    </v-icon>
                  </v-avatar>
                  <p class="text-xs text--secondary mb-1">
                    Taxa de conversão
                  </p>
                  <p class="text-2xl font-weight-semibold text--primary mb-0">
                    {{ taxaConversao }}
                  </p>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-card-text>
  </div>
</template>

<script>
import { mdiChatOutline, mdiRobotOutline, mdiTicketConfirmationOutline, mdiTrendingUp } from '@mdi/js'
import { computed } from '@vue/composition-api'

export default {
  props: {
    dadosAtendimentos: {
      type: Object,
      required: true,
      default: () => {},
    },
    dadosBot: {
      type: Object,
      required: true,
      default: () => {},
    },
  },

  setup(props) {
    const totalAtendimentos = computed(() => props.dadosAtendimentos?.totalAtendimentos ?? 0)
    const totalTickets = computed(() => props.dadosAtendimentos?.totalTicketsAtendidos ?? 0)

    const temDados = computed(() => totalAtendimentos.value > 0 || totalTickets.value > 0)

    const taxaConversao = computed(() => {
      if (!totalAtendimentos.value) return '0%'

      return `${((totalTickets.value / totalAtendimentos.value) * 100).toFixed(1)}%`
    })

    return {
      totalAtendimentos,
      totalTickets,
      taxaConversao,
      temDados,

      icons: {
        mdiRobotOutline,
        mdiChatOutline,
        mdiTicketConfirmationOutline,
        mdiTrendingUp,
      },
    }
  },
}
</script>
